import React, { useEffect, useRef } from 'react';

import Hls from 'hls.js';
import { string } from 'prop-types';

const VideoQuickPlayer = ({ videoUrl, type }) => {
  const videoRef = useRef(null);

  const isEncodedPlaylistFile = videoUrl?.toLowerCase()?.endsWith('.m3u8');

  useEffect(() => {
    const video = videoRef.current;

    if (isEncodedPlaylistFile) {
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoUrl;
      } else if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(videoUrl);
        hls.attachMedia(video);
      }
    }
  }, [isEncodedPlaylistFile, videoUrl]);

  if (isEncodedPlaylistFile) {
    return <video ref={videoRef} width="100%" height="100%" autoPlay loop muted />;
  }
  return (
    <video width="100%" height="100%" autoPlay loop muted>
      <source src={videoUrl} type={type} />
    </video>
  );
};

VideoQuickPlayer.propTypes = {
  videoUrl: string.isRequired
};

export default VideoQuickPlayer;
